// PrivateRoute.tsx
import React from 'react'
import {AUTH_LOCAL_STORAGE_KEY, useAuth} from '../modules/auth'

interface PrivateRouteProps {
  children: React.ReactNode
  allowedRoles: string[]
}

const CustomRoute: React.FC<PrivateRouteProps> = ({children, allowedRoles}) => {
  const {currentUser} = useAuth()
  const userRole = currentUser?.role

  if (!allowedRoles.includes(userRole)) {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
    localStorage.removeItem('userId')
    window.location.href = 'auth/login'
  }

  return <>{children}</>
}

export default CustomRoute
